import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "@emotion/styled";
import InfoIcon from "@mui/icons-material/InfoOutlined";

const Container = styled.div`
  text-align: left;
  font-weight: 100;
  line-height: 1rem;
`;

const IconContainer = styled.div`
  flex: 1;
  text-align: center;
  cursor: pointer;
  margin-right: 5px;
  margin-left: 5px;
`;

const StyledIcon = styled(InfoIcon)`
  width: 13px;
  height: 20px;
  opacity: 0.75;
`;

type Props = {
  children?: React.ReactNode;
  infos: string;
  withImage: boolean;
};

function InfosTooltip({ children, infos, withImage }: Props): JSX.Element {
  return (
    <Container>
      <IconContainer data-tip={infos} data-for="infos">
        {withImage ? <StyledIcon /> : children}
      </IconContainer>
      <ReactTooltip id="infos" html />
    </Container>
  );
}

InfosTooltip.defaultProps = {
  labelStyle: {},
  withImage: true,
};

export default InfosTooltip;
